import moment from 'moment';
import { profileService } from 'src/services/profile.service';

export const getUserIdKey = (key) => {
	return `${key}__${profileService?.profile?.userId ?? ''}`;
};

export const isValidUrl = (url) => {
	if (!url) {
		return;
	}
	const urlPattern =
		// eslint-disable-next-line no-useless-escape
		/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}([-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/;

	return urlPattern.test(url);
};

export const prepareProfileImage = (profile) => {
	if (!profile || !profile.gUId || profile.gToken) {
		return '';
	}

	return;
};

export const formatMilliseconds = (milliseconds) => {
	const duration = moment.duration(milliseconds);
	const days = duration.days();
	const hours = duration.hours();
	const minutes = duration.minutes();
	const seconds = duration.seconds();

	let formattedDuration = '';
	if (days > 0) {
		formattedDuration += `${days} days `;
	}
	if (hours > 0) {
		formattedDuration += `${hours} hrs `;
	}
	if (minutes > 0 && days <= 0) {
		formattedDuration += `${minutes} mins `;
	}
	if (seconds > 0 && days <= 0 && hours <= 0) {
		formattedDuration += `${seconds} secs`;
	}

	return formattedDuration.trim();
};

export const stringToColor = (string) => {
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = '#';

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */
	return color;
};

export const stringAvatar = (name) => {
	const nameParts = name.trim().split(' ');
	const firstInitial = nameParts[0]?.[0] || '';
	const secondInitial = nameParts[1]?.[0] || '';
	return {
		sx: {
			bgcolor: stringToColor(name),
			marginRight: '8px',
		},
		children: `${firstInitial}${secondInitial}`,
	};
};

export const stringAvatar2 = (name) => {
	const nameParts = name.trim().split(' ');
	const firstInitial = nameParts[0]?.[0] || '';
	const secondInitial = nameParts[1]?.[0] || '';
	return {
		sx: {
			bgcolor: '#fac733',
			marginRight: '8px',
		},
		children: `${firstInitial}${secondInitial}`,
	};
};

export const generateDraftId = () => {
	const timestamp = Math.floor(Date.now() / 1000).toString(16);
	const randomPart = [...Array(16)]
		.map(() => Math.floor(Math.random() * 16).toString(16))
		.join('');

	return (timestamp + randomPart).slice(0, 24);
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getNameInitials = (name) => {
  //max 2 letters
  return name
    .replace(/[^a-zA-Z]/g, " ")
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0))
    .slice(0, 2)
    .join("")
    .toUpperCase();
};